import React from 'react';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getParams } from '../common/utils';
import { isIE } from '../common/utils';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { NavLink } from 'react-router-dom';
import { PdfExportButton } from '../common/refButtons';
import { searchActions, cuzkSearchType, cuzkExportPdfType } from '../../store/searchStore';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import MainHeader from './mainHeader';
import Paging from '../common/pagingComponent';
import SimpleSearchStats from '../common/simpleSearchStats';

import './headersCommon.scss'

import flagCz from "../../img/vlajka_cz.svg";

class PropertyCzHeader extends React.Component {
    render() {
        const isOnSearchpage = this.endsWith(this.props.location.pathname, '/property-cz');
        const isOnResultsPage = this.isActiveLink('/results')
        const isOnReportPage = this.endsWith(this.props.location.pathname, '/report');
        const isOnReportDeedPage = this.endsWith(this.props.location.pathname, '/report-ownership-deed');

        return (<>
            <MainHeader label="Property.Header" flag={flagCz} {...this.props} />
            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    <li className={`tab-link ${isOnSearchpage ? "is-active" : ""}`}>
                        <NavLink to={{ pathname: this.props.match.url, state: this.props.location.state }}>
                            <Translate id="Search.Common.Search" />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnSearchpage ? "" : "none" }}></div>
                    </li>
                    <li className={`tab-link ${isOnResultsPage ? "is-active" : ""}`}>
                        <NavLink to={{ pathname: `${this.props.match.url}/results`, state: this.props.location.state }}>
                            <Translate id="Search.Common.Results" />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnResultsPage ? "" : "none" }}></div>
                    </li>
                    {isOnReportPage && <li className={`tab-link ${isOnReportPage ? "is-active" : ""}`}>
                        <NavLink to={{ pathname: `${this.props.match.url}/report`, state: this.props.location.state }}>
                            <Translate id="Common.Report" />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnReportPage ? "" : "none" }}></div>
                    </li>}
                    {isOnReportDeedPage && <li className={`tab-link ${isOnReportDeedPage ? "is-active" : ""}`}>
                        <NavLink to={{ pathname: `${this.props.match.url}/report-ownership-deed`, state: this.props.location.state }}>
                            <Translate id="PropertyCz.Report.OD.OwnershipDeed" />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnReportDeedPage ? "" : "none" }}></div>
                    </li>}
                </ul>
                {!this.endsWith(this.props.location.pathname, '/results') && isOnResultsPage && this.renderPdfExport(cuzkExportPdfType.searchResult, "Common.Button.ExportPdf", false)}
                {(isOnReportPage || isOnReportDeedPage) && this.renderPdfExport(cuzkExportPdfType.expanded, "Common.Button.ExportPdf.Expanded", isOnReportDeedPage)}
                {(isOnReportPage || isOnReportDeedPage) && this.renderPdfExport(cuzkExportPdfType.purchased, isOnReportDeedPage ? "Common.Button.ExportPdf.WholeLv" : "Common.Button.ExportPdf.Purchased", isOnReportDeedPage)}
            </div>}
            {!this.props.isMobile && isOnResultsPage && this.renderSearchManager()}
        </>)
    }

    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;

    isActiveLink = (item) => this.props.location.pathname.indexOf(item) >= 0;

    renderSearchManager = () => {
        const searchResult = this.props.search[cuzkSearchType.subjects];
        if (isNullOrUndefined(searchResult) || isNullOrUndefined(searchResult.data))
            return null;

        const totalPages = Math.ceil(searchResult.data.count / searchResult.pageSize);

        return (
            <div
                className={classnames(
                    "search-results-manager-wrapper",
                    { "relative": isIE() && !this.props.layout.scrolled, "fixed": isIE() && this.props.layout.scrolled, "tinted": this.props.tinted }
                )}
            >
                <div className={classnames("search-results-manager", { "tinted": this.props.tinted })}>
                    <div className="result-counts-ordering-paging" style={{ justifyContent: "space-between" }}>
                        <SimpleSearchStats foundCount={searchResult.data.count} page={searchResult.page} totalPages={totalPages} />
                        {totalPages > 1 && <>
                            <div className='result-paging hide-on-mobile'>
                                <Paging selectedPage={searchResult.page} totalPages={searchResult.data.count} setPage={(pg) => this.props.cuzkSetPage(pg)} />
                            </div>
                            <SimpleSearchStats foundCount={searchResult.data.count} page={searchResult.page} totalPages={totalPages}
                                classNames={{"invisible": true, "hide-on-mobile": true}} />
                        </>}
                    </div>
                </div>
            </div>
        )
    }

    renderPdfExport = (exportType, titleKey, isOnReportDeedPage) => {
        var data;
        if (exportType === cuzkExportPdfType.searchResult)
            data = (isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search[cuzkSearchType.subjects]) ? null : this.props.search[cuzkSearchType.subjects].data);
        else
            data = (isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search[cuzkSearchType.report])) ? null : this.props.search[cuzkSearchType.report].data;

        if (isNullOrUndefined(data))
            return null;

        return (
            <div className='search-pdf-export'>
                <div className='references print-hidden'>
                    <div className="ref-buttons" style={{ display: 'flex' }}>
                        <PdfExportButton key={exportType} titleKey={titleKey} onClick={() => exportType === cuzkExportPdfType.searchResult ? this.props.cuzkExportSearchResultPdf(getParams(window.location.search)) : this.props.cuzkExportReportPdf(exportType, isOnReportDeedPage)} />
                    </div>
                </div>
            </div>);
    }
}

export default withRouter(connect(
    state => ({ search: { ...state.search.cuzk }, layout: { ...state.layout } }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(PropertyCzHeader));